// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__1HB3q","info":"PatientInfo_info__3pfzN"};